import React from 'react';
import { Card, Descriptions, Spin, Button, Space, Avatar } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useBankDetail } from '../../hooks/useBanks';

const BankDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { bank, loading } = useBankDetail(id || '');

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  if (!bank) return <Card>Không tìm thấy ngân hàng.</Card>;

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/banks')}>Quay lại</Button>
      <Card title={
        <Space>
          {bank.logo ? <Avatar src={bank.logo} shape="square" /> : <Avatar shape="square">{bank.short_name?.[0]}</Avatar>}
          {`Ngân hàng · ${bank.name}`}
        </Space>
      }>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Tên đầy đủ">{bank.name}</Descriptions.Item>
          <Descriptions.Item label="Tên rút gọn">{bank.short_name}</Descriptions.Item>
          <Descriptions.Item label="Mã">{bank.code}</Descriptions.Item>
          <Descriptions.Item label="BIN">{bank.bin}</Descriptions.Item>
          <Descriptions.Item label="SWIFT">{bank.swift_code || '—'}</Descriptions.Item>
          <Descriptions.Item label="Thứ tự">{bank.ordering}</Descriptions.Item>
          <Descriptions.Item label="Logo URL" span={2}>
            <a href={bank.logo} target="_blank" rel="noreferrer">{bank.logo}</a>
          </Descriptions.Item>
          <Descriptions.Item label="Tenant ID" span={2}><code>{bank.tenant_id || '—'}</code></Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};

export default BankDetail;
export { BankDetail };
